import http from 'plugins/axios';

export default {
  getList(data) {
    return http.post({
      url: '/la/admin/loginlog/search',
      data,
      dataType: 'form'
    });
  }
};
